import { render, staticRenderFns } from "./CriarReserva.vue?vue&type=template&id=324a89a3&scoped=true"
import script from "./CriarReserva.vue?vue&type=script&lang=js"
export * from "./CriarReserva.vue?vue&type=script&lang=js"
import style0 from "./CriarReserva.vue?vue&type=style&index=0&id=324a89a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a89a3",
  null
  
)

export default component.exports